import styled from 'styled-components';
import { Layout } from 'antd';

const { Footer } = Layout;

export const FooterWrapper = styled(Footer)`
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  .menu-wrapper {
    display: flex;
    padding: 0;
    margin: 0;
    list-style: none;
    .menu-item {
      display: block;
      padding: 0;
      .menu-link {
        color: #7e8299;
        padding: 0.65rem 1rem;
      }
    }
  }
`;
